import { addMonths, set } from 'date-fns';

import { formatDate } from 'helpers/date';

import { periodLocales } from '../../common/periodLocales';
import { TimeFrameType } from '../../types';

const formatTimeFrameDate = (date: string) => {
  return formatDate(new Date(date), 'P');
};
export const formatTimeframeType = (
  timeframeType: TimeFrameType,
  startDate: string,
  endDate: string,
) => {
  const language = periodLocales.getLanguage();
  if (language === 'en') {
    if (timeframeType === TimeFrameType.CUSTOM_TIMEFRAME) {
      return `from **${formatTimeFrameDate(
        startDate,
      )}** to **${formatTimeFrameDate(endDate)}**`;
    }
    return `for the **${periodLocales[timeframeType].toLowerCase()}**`;
  }

  switch (timeframeType) {
    case TimeFrameType.CUSTOM_TIMEFRAME:
      return `du **${formatTimeFrameDate(
        startDate,
      )}** au **${formatTimeFrameDate(endDate)}**`;
    case TimeFrameType.CURRENT_YEAR:
      return `de l'**${periodLocales[timeframeType].toLowerCase()}**`;
    case TimeFrameType.LAST_3_MONTHS:
      return `des **${periodLocales[timeframeType].toLowerCase()}**`;
    case TimeFrameType.CURRENT_MONTH:
    case TimeFrameType.LAST_MONTH:
      return `du **${periodLocales[timeframeType].toLowerCase()}**`;
    default:
      return '';
  }
};

export const formatNextMonth5th = () => {
  const today = new Date();
  const nextMonth = addMonths(today, 1);
  const thirdNextMonth = set(nextMonth, { date: 5 });

  return formatDate(thirdNextMonth, 'PPP');
};
